import { createClient } from "@supabase/supabase-js";

function createSupabaseClient() {
  const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || process.env.SUPABASE_URL;
  const SUPABASE_PUBLISHABLE_KEY =
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || process.env.SUPABASE_PUBLISHABLE_KEY;

  if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
    const missing = [
      ...(!SUPABASE_URL ? ["SUPABASE_URL"] : []),
      ...(!SUPABASE_PUBLISHABLE_KEY ? ["SUPABASE_PUBLISHABLE_KEY"] : []),
    ];
    const message =
      `Missing Supabase environment variable(s): ${missing.join(", ")}. ` +
      `Check .env locally, or \`npx wrangler secret put\` / [vars] in wrangler.toml.`;
    console.error(`[Supabase] ${message}`);
    throw new Error(message);
  }

  // New-style publishable keys are not JWTs, so they must not ride on
  // Authorization: Bearer. The gateway rejects them there with "Invalid JWT".
  const isNewStyleKey = SUPABASE_PUBLISHABLE_KEY.startsWith("sb_");

  return createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    ...(isNewStyleKey ? { global: { headers: { apikey: SUPABASE_PUBLISHABLE_KEY } } } : {}),
    auth: {
      storage: typeof window !== "undefined" ? localStorage : undefined,
      persistSession: true,
      autoRefreshToken: true,
    },
  });
}

let _supabase;

export const supabase = new Proxy(
  {},
  {
    get(_, prop, receiver) {
      if (!_supabase) _supabase = createSupabaseClient();
      return Reflect.get(_supabase, prop, receiver);
    },
  },
);
